export enum ServiceChargeMode {
  Percentage = 1,
  Monetary = 2
};
